<template>
<div class="chapter">
<div class="inner_page">
<p class="fm-head">ACKNOWLEDGEMENTS</p>
<p class="noindent">First and foremost, I must thank my wife, Stefanie. She has always been my biggest supporter and number-one fan, and her belief in me has kept me going. We are empty nesters, going on a few years now, and my work on this book and other projects has made the adjustment much harder than it needed to be. But I have big plans to make it all right!</p>
<p class="indent">I also have to give a shout-out to my editor, Kate Jenkins, copy editor Rick Delaney and all the good folks at The History Press. I cannot thank them enough for taking a chance on me and this book. I am truly grateful for the opportunity.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Acknowledgements.vue?d2d5a70e